<mat-form-field appearance="outline" color="primary" class="w-full user-input">
  <mat-chip-grid #chipList *ngIf="enableChips">
    <mat-chip-row selected *ngFor="let email of emailList; let i = index" [removable]="removable" (removed)="removeEmail(email)" required name="chips">
      {{ email }}
      <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
    </mat-chip-row>
    <input
      matInput
      [value]="value"
      [disabled]="isDisabled"
      (input)="onChange($event)"
      (blur)="onTouched()"
      placeholder="Type e-mail"
      i18n-placeholder
      type="email"
      #chipInput
      [matAutocomplete]="auto"
      [spMatChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="true"
      (matChipInputTokenEnd)="add($event)"
    />
  </mat-chip-grid>

  <input
    matInput
    [value]="value"
    [disabled]="isDisabled"
    (input)="onChange($event)"
    (blur)="onTouched()"
    placeholder="Type e-mail"
    i18n-placeholder
    [matAutocomplete]="auto"
    type="email"
    *ngIf="!enableChips"
    #emailInput
  />
  <mat-icon matSuffix class="cursor-pointer" (click)="addLoggedInUserEmail()">person</mat-icon>
  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="selectionOptions($event.option.value)">
    <mat-option *ngFor="let user of users" [value]="user">
      {{ user.email }}
    </mat-option>
  </mat-autocomplete>
  <mat-error *ngIf="required"> {{ requiredText }} </mat-error>
</mat-form-field>
